import { computed, DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { ScreenDimensionService } from '../services/screen-dimension.service';

@Directive({
  selector: '[appElementScreenSize]',
  standalone: true,
  exportAs: 'elementScreenSize',
})
export class ElementScreenSizeDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);
  private readonly screenDimensions = inject(ScreenDimensionService);

  readonly width = this.screenDimensions.createElementWidthSignal(
    this.elementRef.nativeElement,
    this.destroyRef
  );

  readonly isMobile = computed(() => this.screenDimensions.isMobileWidth(this.width()));
}
